<template>
  <nav class="main-menu">
    <ul class="main-menu__list">
      <li class="main-menu__item">
        <a href="http://www.pro-inwest.org/" target="_blank" title="O firmie">O firmie</a>
      </li>
      <li class="main-menu__item">
        <a @click="showSection('o-projekcie')"  title="O centrum">O centrum</a>
      </li>
      <li class="main-menu__item">
        <a @click="showSection('korzysci')" title="Korzyści">Korzyści</a>
      </li>
      <li class="main-menu__item">
        <a @click="showSection('oferta')" title="Oferta">Oferta</a>
      </li>
      <li class="main-menu__item">
        <a @click="showSection('kontakt')"  title="Kontakt">Kontakt</a>
      </li>
      <li class="main-menu__item">
        <a @click="$router.push({ path: '/dofinansowanie'})"
           title="Dofinansowanie">Dofinansowanie</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'main-menu',
  methods: {
    showSection(section) {
      this.$router.push({ path: '/', query: { sekcja: section } });
      this.$emit('menu-clicked');
    },
  },
};
</script>

